"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fabricateCustodyDepositCollateral = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const create_hook_msg_1 = require("../../utils/cw20/create-hook-msg");
const validate_input_1 = require("../../utils/validate-input");
const address_1 = require("../../utils/validation/address");
const number_1 = require("../../utils/validation/number");
const fabricateCustodyDepositCollateral = ({ address, bAsset, amount }) => (_) => {
    (0, validate_input_1.validateInput)([
        (0, address_1.validateAddress)(address),
        (0, number_1.validateIsGreaterThanZero)(amount),
    ]);
    // cw20 send + provide_collateral hook
    return [
        // provide_collateral call
        new terra_js_1.MsgExecuteContract(address, bAsset.token(), {
            send: {
                contract: bAsset.custody(),
                amount: new terra_js_1.Int(new terra_js_1.Dec(amount).mul(1000000)).toString(),
                msg: (0, create_hook_msg_1.createHookMsg)({
                    deposit_collateral: {},
                }),
            },
        }),
    ];
};
exports.fabricateCustodyDepositCollateral = fabricateCustodyDepositCollateral;
//# sourceMappingURL=custody-deposit-collateral.js.map